// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/clinic/:clinicSlug\",\"regex\":\"^/clinic/([^/]+)$\",\"paramNames\":[\"clinicSlug\"],\"hasOptionalPrefix\":false},{\"path\":\"/invite/:token\",\"regex\":\"^/invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/ordinex/:secret\",\"regex\":\"^/ordinex/([^/]+)$\",\"paramNames\":[\"secret\"],\"hasOptionalPrefix\":false},{\"path\":\"/ordinex/:secret/import\",\"regex\":\"^/ordinex/([^/]+)/import$\",\"paramNames\":[\"secret\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin\"},{\"path\":\"/admin/account\"},{\"path\":\"/admin/appointment-types\"},{\"path\":\"/admin/billing\"},{\"path\":\"/admin/bookings\"},{\"path\":\"/admin/calendar\"},{\"path\":\"/admin/clinic-profile\"},{\"path\":\"/admin/contact\"},{\"path\":\"/admin/guides\"},{\"path\":\"/admin/guides/account\"},{\"path\":\"/admin/guides/billing\"},{\"path\":\"/admin/guides/booking-troubleshooting\"},{\"path\":\"/admin/guides/calendar\"},{\"path\":\"/admin/guides/clean-calendar\"},{\"path\":\"/admin/guides/excel-import\"},{\"path\":\"/admin/guides/gradual-transition\"},{\"path\":\"/admin/guides/manual-adding\"},{\"path\":\"/admin/guides/new-reservation\"},{\"path\":\"/admin/guides/notifications\"},{\"path\":\"/admin/guides/online-reservations\"},{\"path\":\"/admin/guides/patient-messages\"},{\"path\":\"/admin/guides/patient-page\"},{\"path\":\"/admin/guides/schedule-setup\"},{\"path\":\"/admin/guides/staff-roles\"},{\"path\":\"/admin/guides/time-blocking\"},{\"path\":\"/admin/onboarding\"},{\"path\":\"/admin/patients\"},{\"path\":\"/admin/providers\"},{\"path\":\"/admin/settings\"},{\"path\":\"/admin/staff\"},{\"path\":\"/book\"},{\"path\":\"/cancel\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/registration\"},{\"path\":\"/reset-password\"},{\"path\":\"/sentry-example-page\"},{\"path\":\"/subscription-paused\"},{\"path\":\"/test-appointments-import\"},{\"path\":\"/test-email\"},{\"path\":\"/test-sentry\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

// Only initialize Sentry in production
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://872dc3475cf86a811bf651b0ba429f01@o4510062054146048.ingest.de.sentry.io/4510062061420624",

    // Add optional integrations for additional features
    // Safely check for WebKit context to prevent messageHandler errors
    integrations: (() => {
      const integrations = [];

      // Only add replay integration if we can safely access it
      try {
        if (typeof window !== "undefined") {
          // Check if we're in a WebKit context that might have messageHandler issues
          const webkit = (window as any).webkit;
          const hasWebKitHandlers = webkit && webkit.messageHandlers;
          const isIOSWebView =
            /iPhone|iPad|iPod/.test(navigator.userAgent) && webkit;

          // Skip replay integration in problematic contexts
          if (!hasWebKitHandlers && !isIOSWebView) {
            integrations.push(Sentry.replayIntegration());
          }
        }
      } catch (error) {
        // If any error occurs during detection, skip replay integration for safety
        console.warn(
          "Sentry replay integration skipped due to WebKit detection error:",
          error
        );
      }

      return integrations;
    })(),

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,
    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
